import React from 'react';
import { Content, Row, Col, ScrollLayout, Text } from 'components';
import { Collapse, Empty, Flex, Tag } from 'antd';
import { stringToMoneyFormat } from 'utils';
import Formatter from 'utils/Formatter';
import CONSTANTS from 'constants';

const PAYMENT_STATE = {
  PENDING: '결제 대기',
  COMPLETED: '결제 완료',
  CANCELLED: '결제 취소',
  FAILED: '결제 실패',
  REFUNDED: '환불 완료',
};

const DELIVERY_STATUS = {
  PENDING: '상품준비중',
  SHIPPING: '배송중',
  DELIVERED: '배송완료',
};

const ORDER_TYPE = {
  DELIVERY: '배송상품',
  SUBSCRIPTION: '정기상품',
  RENTAL: '렌탈상품',
};

/**
 * 메뉴 아이템
 * @param {*} param0
 * @returns
 */
const MenuItem = ({ style, order }) => {
  return (
    <Collapse style={{ ...style }}>
      <Collapse.Panel
        header={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <p>[주문번호] {order?.order_id}</p>
              <p>
                [주문일]{' '}
                {Formatter.unixToDate(order?.created_at, 'YYYY-MM-DD HH:mm:ss')}
              </p>
            </div>
            <div
              style={{
                width: '30%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 10,
                }}
              >
                <p>
                  결제금액:{' '}
                  <span>{stringToMoneyFormat(order?.final_price, '원')}</span>
                </p>
                <Text size={14} align={'left'}>
                  주문경로: {order?.order_route}
                </Text>
              </div>
              <Tag>{PAYMENT_STATE[order?.payment_state]}</Tag>
            </div>
          </div>
        }
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              borderRight: '1px solid #F5F5F5',
            }}
          >
            <Text size={16} weight={700} align={'center'}>
              주문 메뉴
            </Text>
            {order?.product_information?.map((product, productIndex) => (
              <div key={`product-${order?.order_id}-${productIndex}`}>
                <Text size={14} weight={600}>
                  {product.menu_name}
                </Text>
                {product?.menu_option?.map((option, optionIndex) => (
                  <Text
                    size={12}
                    key={`product-${order?.order_id}-${product?.menu_id}-${productIndex}-${optionIndex}`}
                  >
                    ㄴ{option?.option_title} ({option?.option[0]?.option_name})
                    +{stringToMoneyFormat(option?.option[0]?.option_price)}
                  </Text>
                ))}
              </div>
            ))}
          </div>

          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '0px 16px',
              borderRight: '1px solid #F5F5F5',
            }}
          >
            <Text size={16} weight={700} align={'center'}>
              할인/쿠폰
            </Text>
            {order?.coupon_info?.map((coupon) => (
              <Text key={`coupon-${coupon?.coupon_user_id}`} size={14}>
                {coupon?.coupon_name} (
                {stringToMoneyFormat(coupon?.discount_price, '원')})
              </Text>
            ))}
            <Text size={14}>
              사용 포인트: {stringToMoneyFormat(order?.use_point, 'P')}
            </Text>
          </div>

          <div
            style={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 10,
              padding: '0px 16px',
            }}
          >
            <Text size={16} weight={700} align={'center'}>
              결제정보
            </Text>

            <Text size={14}>
              결제수단: {CONSTANTS.PAYMENT_METHOD[order?.payment_method]}
            </Text>
            {order?.cash_bill_info ? (
              <React.Fragment>
                <Text size={14}>
                  현금영수증 승인번호:{' '}
                  {order?.cash_bill_info?.cashbillNumb ?? '-'}
                </Text>
                <Text size={14}>
                  현금영수증 승인금액:{' '}
                  {stringToMoneyFormat(
                    order?.cash_bill_info?.totalAmount,
                    '원'
                  ) ?? '-'}
                </Text>
                <Text size={14}>
                  현금영수증 승인일:{' '}
                  {order?.cash_bill_info?.tradeDateTime ?? '-'}
                </Text>
              </React.Fragment>
            ) : null}
          </div>
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};

/**
 * 프로덕트 아이템
 * @param {*} param0
 * @returns
 */
const ProductItem = ({ style, order }) => {
  return (
    <Collapse style={{ ...style }}>
      <Collapse.Panel
        header={
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <p>[주문번호] {order?.shop_order_id}</p>
              <p>
                [주문일]{' '}
                {Formatter.unixToDate(order?.created_at, 'YYYY-MM-DD HH:mm:ss')}
              </p>
            </div>
            <div
              style={{
                width: '30%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: 10,
                }}
              >
                <p>
                  결제금액:{' '}
                  <span>{stringToMoneyFormat(order?.final_price, '원')}</span>
                </p>
                <Text size={14} align={'left'}>
                  주문경로: {order?.order_route}
                </Text>
              </div>
              <Tag>{ORDER_TYPE[order?.type]}</Tag>
            </div>
          </div>
        }
        styles={{ body: { padding: 0 } }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              flex: 2,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {order?.parcel_service?.map((parcel, productIndex) => (
              <Flex
                key={`product-${parcel?.parcel_service_id}-${productIndex}`}
                align="stretch"
                style={{ borderBottom: '1px solid #F5F5F5', padding: 16 }}
              >
                <Flex vertical style={{ flex: 1 }}>
                  <Text size={14} weight={700}>
                    주문 상품
                  </Text>
                  <div style={{ padding: '10px 0px' }}>
                    <Flex align="center" gap={10}>
                      <Text size={14} weight={600}>
                        {parcel?.product?.product_name}
                      </Text>

                      <Tag>{DELIVERY_STATUS[parcel.delivery_status]}</Tag>
                    </Flex>
                    {parcel.product?.product_option?.map(
                      (option, optionIndex) => (
                        <Text
                          size={12}
                          key={`product-${parcel?.parcel_service_id}-${productIndex}-${optionIndex}`}
                        >
                          ㄴ{option?.option_title} (
                          {option?.option[0]?.option_name}) +
                          {stringToMoneyFormat(option?.option[0]?.option_price)}
                        </Text>
                      )
                    )}
                  </div>

                  <div
                    style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {parcel?.coupon_info ? (
                      <Text size={12}>
                        {parcel?.coupon_info?.policy_coupon?.coupon_name} (
                        {stringToMoneyFormat(
                          parcel?.coupon_info?.discount_price,
                          '원'
                        )}
                        )
                      </Text>
                    ) : null}

                    <Text size={12}>
                      사용 포인트: {stringToMoneyFormat(parcel?.use_point, 'P')}
                    </Text>
                  </div>
                </Flex>

                <Flex vertical style={{ padding: '0px 10px' }}>
                  <Text size={14} weight={700}>
                    결제정보
                  </Text>

                  <Text size={14}>
                    결제수단: {CONSTANTS.PAYMENT_METHOD[parcel?.payment_method]}
                  </Text>

                  <Text size={14}>
                    결제금액: {stringToMoneyFormat(parcel?.payment_price)}
                  </Text>
                </Flex>
              </Flex>
            ))}
          </div>
        </div>
      </Collapse.Panel>
    </Collapse>
  );
};

const OrderHistory = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { keyType = 'order', data = [] } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <Content maxWidth={'100%'}>
      <Row>
        <Col x={24}>
          <ScrollLayout
            style={{
              width: '100%',
              maxHeight: document.body.clientHeight * 0.8,
              height: document.body.clientHeight * 0.8,
            }}
          >
            {!data.length ? (
              <div
                style={{
                  display: 'flex',
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Empty description={'주문 내역이 없습니다.'} />
              </div>
            ) : (
              data.map((order, index) =>
                keyType === 'order' ? (
                  <MenuItem
                    key={`${keyType}_id-${index}`}
                    style={{ marginBottom: 10 }}
                    order={order}
                  />
                ) : (
                  <ProductItem
                    key={`${keyType}_id-${index}`}
                    style={{ marginBottom: 10 }}
                    order={order}
                  />
                )
              )
            )}
          </ScrollLayout>
        </Col>
      </Row>
    </Content>
  );
};

export default OrderHistory;
